import { normalizeAuthTokenForDecode } from "./routeAccess";

/** Raw JWT string for `Authorization: Bearer …` from context/cookie value. */
export function getBearerTokenFromSession(raw) {
  const s = normalizeAuthTokenForDecode(raw);
  return typeof s === "string" && s.length > 0 ? s : null;
}

/** `{ Authorization: "Bearer …" }` or `{}` if no token. */
export function getAuthorizationHeaderObject(raw) {
  const t = getBearerTokenFromSession(raw);
  return t ? { Authorization: `Bearer ${t}` } : {};
}
